import {
    type ParentPermissionRecipientForApollo,
    type ParentPermissionRecipientFromRest,
} from './parent-permission-recipient';

export const parentPermissionRecipientTypePatcher = (
    data: ParentPermissionRecipientFromRest,
): ParentPermissionRecipientForApollo => {
    return {
        __typename: 'ParentPermissionRecipient',
        ...data,
    };
};
